import React from "react";
import Column from "@amzn/meridian/column";
import Button from "@amzn/meridian/button";
import { useNavigate } from "react-router-dom";
const LandingFooter = () => {
  const navigate = useNavigate();
  return (
    <Column spacingInset="500">
      <Button size="large" onClick={() => navigate("/templates")}>
        Start New Inspection
      </Button>
    </Column>
  );
};

export default LandingFooter;
